// extracted by mini-css-extract-plugin
module.exports = {"ChannelEventsPrimaryContainer":"ChannelEvents_ChannelEventsPrimaryContainer__ZPa6L"};